
import { defineComponent, computed } from 'vue'
import { useStore, Store } from '@/store'
import { useRoute, useRouter } from 'vue-router'

/**
 * 境界立会仮申請ログイン
 * URLのトークンから認証を行い、認証失敗時はエラーページに遷移する
 */
export default defineComponent({
  name: 'TmpBoundaryLogin',
  setup() {
    const store = useStore() as Store
    const route = useRoute()
    store.dispatch('tmpBoundary/logout')

    const isLogin = computed(() => {
      return store.getters['tmpBoundary/isLogin']
    })

    // URLからトークン取得
    const urlToken = route.params.token
    if (typeof urlToken !== 'string' || urlToken === '') {
      const router = useRouter()
      const errPath = route.meta.loginPath
      if (errPath == null) {
        // エラーページ未設定の場合はエラー
        throw new Error('undefined login path')
      }
      // トークンが無い場合エラーページに飛ばす
      router.push(errPath)
    } else {
      // tokenが有る場合認証する
      store.dispatch('tmpBoundary/login', { urlToken: urlToken })
    }
    return { isLogin }
  },
})
